import { Component, OnInit } from '@angular/core';
import { createPriceAgreementsMockData } from './price-agreements.mock';
import { ExpiringAgreement, Summary } from './types';

@Component({
  selector: 'dashboard-price-agreements',
  templateUrl: './price-agreements.component.html',
  styleUrls: ['./price-agreements.component.scss']
})
export class DashboardPriceAgreementsComponent implements OnInit {
  summary: Summary = {
    active: 0,
    expiringSoon: 0,
    blocked: 0
  }
  expireList: ExpiringAgreement[] = []

  constructor() { }

  ngOnInit(): void {
    const mockData = createPriceAgreementsMockData();
    this.summary = mockData.summary;
    this.expireList = mockData.expireList;
  }

}
